/**
 * Slice C.1 · BookingPreview.
 * Reads canonical `presentation.data` (booking_preview shape).
 * Never invents fields.
 */
export function BookingPreview({ presentation }) {
  const d = presentation.data || {};
  const pupil   = typeof d.pupil_name    === "string" ? d.pupil_name    : null;
  const dateStr = typeof d.date          === "string" ? d.date          : null;
  const time    = typeof d.start_time    === "string" ? d.start_time    : null;
  const dur     = Number.isFinite(d.duration_minutes) ? d.duration_minutes : null;
  const price   = Number.isFinite(d.price_pounds) ? d.price_pounds : null;

  return (
    <div data-testid="ui-response-booking-preview" className="space-y-2">
      <p className="text-[14px] leading-relaxed text-zinc-100">
        {presentation.narration}
      </p>
      <dl className="text-[13px] grid grid-cols-2 gap-x-3 gap-y-1 text-zinc-300">
        {pupil   && (<><dt className="text-zinc-500">Pupil</dt><dd data-testid="ui-booking-pupil">{pupil}</dd></>)}
        {dateStr && (<><dt className="text-zinc-500">Date</dt><dd data-testid="ui-booking-date">{dateStr}</dd></>)}
        {time    && (<><dt className="text-zinc-500">Time</dt><dd data-testid="ui-booking-time">{time}</dd></>)}
        {dur !== null && (<><dt className="text-zinc-500">Length</dt><dd data-testid="ui-booking-duration">{dur} min</dd></>)}
        {price !== null && (<><dt className="text-zinc-500">Price</dt><dd data-testid="ui-booking-price">£{price.toFixed(2)}</dd></>)}
      </dl>
    </div>
  );
}

export default BookingPreview;
